import { render, staticRenderFns } from "./multiAccountDashboard.vue?vue&type=template&id=2bf721d8&scoped=true"
import script from "./multiAccountDashboard.vue?vue&type=script&lang=js"
export * from "./multiAccountDashboard.vue?vue&type=script&lang=js"
import style0 from "./multiAccountDashboard.vue?vue&type=style&index=0&id=2bf721d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf721d8",
  null
  
)

export default component.exports